import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SideMenuPatientRoutingModule } from './side-menu-patient-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { SidemenuPatientComponent } from './sidemenu.component';


@NgModule({
  declarations: [SidemenuPatientComponent],
  imports: [
    CommonModule,
    SideMenuPatientRoutingModule,
    TranslateModule
  ]
  ,
  exports:[
    SidemenuPatientComponent
  ]
})
export class SideMenuPatientModule { }
